import React from 'react'
import ProductForm from 'views/shared/ProductForm'
import BSCornMasaFlourProduct from 'models/BSCornMasaFlourProduct'
import BSCornMasaFlourPackage from './BSCornMasaFlourPackage'

const productOptions = {
  packagingInfo: <BSCornMasaFlourPackage />,
  productTitle: 'Brand Specific Corn Masa Flour',
  model: BSCornMasaFlourProduct,
  validCategories: ['16'],
  validSubCategories: ['016BS'],
  brandSpecific: true,
}

const BSCornMasaFlour = () => <ProductForm product={productOptions} />

export default BSCornMasaFlour
